import { useCallback } from 'react';
import { CardStyle } from './types';

// ============================================================================
// Style Configurations
// ============================================================================

export const styleConfig = {
  [CardStyle.Elevated]: {
    container: 'bg-neutral-100 shadow-md hover:shadow-lg',
  },
  [CardStyle.Outlined]: {
    container: 'bg-neutral-100 border border-neutral-80',
  },
  [CardStyle.Filled]: {
    container: 'bg-neutral-95',
  },
};

export const paddingConfig = {
  none: '',
  small: 'p-2',
  medium: 'p-4',
  large: 'p-6',
};

export const alignConfig = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
  'space-between': 'justify-between',
};

// ============================================================================
// Hook Props & Return Types
// ============================================================================

export interface UseCardProps {
  style?: CardStyle | undefined;
  clickable?: boolean | undefined;
  onClick?: ((e: React.MouseEvent) => void) | undefined;
}

export interface UseCardReturn {
  styleClasses: { container: string };
  handleClick: (e: React.MouseEvent) => void;
}

// ============================================================================
// useCard Hook
// ============================================================================

export const useCard = ({
  style = CardStyle.Elevated,
  clickable = false,
  onClick,
}: UseCardProps): UseCardReturn => {
  const styleClasses = styleConfig[style];

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (clickable && onClick) {
        onClick(e);
      }
    },
    [clickable, onClick]
  );

  return {
    styleClasses,
    handleClick,
  };
};
